import { render, staticRenderFns } from "./mobile-course-drawer.vue?vue&type=template&id=48d6079f"
import script from "./mobile-course-drawer.vue?vue&type=script&lang=js"
export * from "./mobile-course-drawer.vue?vue&type=script&lang=js"
import style0 from "./mobile-course-drawer.vue?vue&type=style&index=0&id=48d6079f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports